import { Component, Input } from '@angular/core';
import orderBy from 'lodash-es/orderBy';
import { SeatTranslatorService } from 'libs/core/src/lib/service/seat/seat-translator.service';
import { SeatViewModel } from 'libs/core/src/lib/model/view-model/screen/seat/seat.view.model';
import { ScreenViewModel } from 'libs/core/src/lib/model/view-model/screen/screen.view.model';

@Component({
  template: ''
})
export class ScreenSeatsSelectedListComponent {
  public seatsSelected: SeatViewModel[] = [];
  public seatsSelectedGroupedByRow: { row: string; seats: string; count: number }[] = [];
  showList = false;

  @Input() screen: ScreenViewModel;
  private _seatIds: string[];
  @Input()
  set seatIds(value: string[]) {
    if (!this._seatIds || !value || this._seatIds.length !== value.length) {
      this.prepareSeatsSelected(value);
    }
  }

  private prepareSeatsSelected(seatIds: string[] = []) {
    this._seatIds = seatIds;
    if (seatIds.length && this.screen) {
      let filteredScreenSeats: SeatViewModel[] = [];

      if (this.screen.pseats) {
        filteredScreenSeats = this.screen.pseats.flat().filter((item: SeatViewModel) => seatIds.indexOf(item.id) !== -1);
      } else if (this.screen.seats) {
        filteredScreenSeats = this.screen.seats.filter((item: SeatViewModel) => seatIds.indexOf(item.id) !== -1);
        filteredScreenSeats.forEach((item: SeatViewModel) => {
          item.adaptScreenModel(
            { ...this.screen, defaultSeatDescription: '' },
            this.screen.rows.find((row) => row.id === item.rowId).toApiModel(),
            this.screen.cols.find((col) => col.id === item.colId).toApiModel()
          );
        });
      }

      const seatsSelected: SeatViewModel[] = [];

      filteredScreenSeats.forEach((elem: SeatViewModel) => {
        seatsSelected.push(elem);

        if (elem.groupConnectedSeats != null) {
          elem.groupConnectedSeats.forEach((celem: SeatViewModel) => {
            seatsSelected.push(celem);
          });
        }
      });

      const skippingRomanDigitsInRows = SeatTranslatorService.isNotRomanDigit(seatsSelected.map((elem) => elem.rowSymbol));
      const skippingRomanDigitsInCols = SeatTranslatorService.isNotRomanDigit(seatsSelected.map((elem) => elem.symbol));

      seatsSelected.forEach((elem) => {
        elem.translateRow = SeatTranslatorService.translateValue(elem.rowSymbol, skippingRomanDigitsInRows);
        elem.translateCol = SeatTranslatorService.translateValue(elem.symbol, skippingRomanDigitsInCols);
      });

      this.seatsSelected = orderBy(seatsSelected, ['translateRow', 'translateCol']);
      const grouped = this.seatsSelected.reduce((acc, seat) => {
        if (!acc[seat.rowSymbol]) acc[seat.rowSymbol] = [];
        acc[seat.rowSymbol].push(seat);
        return acc;
      }, {} as { [row: string]: SeatViewModel[] });
      this.seatsSelectedGroupedByRow = Object.entries(grouped).map(([row, seats]) => ({
        row,
        seats: seats.map((seat) => seat.symbol).join(', '),
        count: seats.length
      }));
    } else {
      this.showList = false;
      this.seatsSelectedGroupedByRow = [];
      this.seatsSelected = [];
    }
  }
}
